import React from 'react';


import CheckBox from 'devextreme-react/check-box';

export const FormCheckBox = ({
  value,
  readOnly,

  label,

  onValueChange,
  children
}) => {
  return (
    <CheckBox
    text={label}
    width='100%'  
    value={value}
    readOnly={readOnly}
    stylingMode='filled'
    inputAttr={{ class: 'form-editor-input' }}
    onValueChange={onValueChange}

   >
        {children}
    </CheckBox>
  );
};
